if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeSlide = this.querySelector(`.product-media-modal__slide[data-media-id="${mediaId}"]`);
        if (!activeSlide) return;
        activeSlide.classList.add('active');
        activeSlide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });

        const deferredMedia = activeSlide.querySelector('deferred-media');
        if (!deferredMedia) return;
        const activeMediaTemplate = deferredMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMediaContent && activeMediaContent.querySelector('.js-youtube')) deferredMedia.loadContent();
      }
    }
  );
}

if (!customElements.get('media-modal-slider')) {
  customElements.define(
    'media-modal-slider',
    class MediaModalSlider extends SliderComponent {
      constructor() {
        super();
        this.enableSliderLooping = true;
        if (this.prevButton) this.prevButton.removeAttribute('disabled');
        if (this.nextButton) this.nextButton.removeAttribute('disabled');
      }

      onButtonClick(event) {
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.totalPages;

        if (isLastSlide && event.currentTarget.name === 'next') {
          event.preventDefault();
          this.setSlidePosition(0);
          return;
        }

        if (isFirstSlide && event.currentTarget.name === 'previous') {
          event.preventDefault();
          this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset * (this.sliderItemsToShow.length - 1));
          return;
        }

        super.onButtonClick(event);
      }
    }
  );
}
